import React from "react";
import styles from "./card-favorite-buttons.module.css";
import { useDispatch, useSelector } from "react-redux";
import { toFavoriteList, toggleFavorite } from "../../store/reducers/list/arcanaList";
import { selectIsFavorite } from "../../store/selectors/arcanaSelectors";
import { getUIText } from "../../translation";

export default function CardFavoriteButton({ lang, arcana, isOffImage }) {
    const isFavorite = useSelector((state) => selectIsFavorite(state, arcana.id));

    const dispatch = useDispatch();

    return (
        <button
            className={`${styles["favorite-button"]} ${isFavorite ? `${styles["active"]}` : ""}`}
            title={getUIText(lang, "arcana.card.buttons.favorite.title")}
            onClick={(e) => {
                e.stopPropagation();
                dispatch(toggleFavorite(arcana.id));
            }}
        >
            <svg viewBox="0 0 24 24" style={isOffImage ? { fill: "#333" } : {}}>
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path>
            </svg>
        </button>
    );
}
